import styled, { css } from 'styled-components';

export const TempMailContent = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowPure};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: ${theme.v2.font.lineHeight.text};
    margin: 0px;
  `}
`;

export const TempMailContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ActionsWrapper = styled.div`
  ${({ theme }) => css`
    align-items: center;
    display: flex;
    flex-direction: row;
    gap: 16px;
    justify-content: flex-end;
    margin-top: 8px;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      flex-direction: column;
      width: 100%;
    }
  `}
`;
